// AI-CONTEXT: See docs/features/update-aanvragen-afgerond-mail.md
// De koppeling tussen een updateverzoek en de update die het opleverde:
// `UpdateRequests.UpdateID` wijst naar een `id` in src/data/updates.json.

/**
 * @typedef {object} UpdateEntry
 * @property {string} id - Uniek id, bv. '2026-09-10-melding-id-verloopt-en-verjaardag'
 * @property {string} date - ISO-datum
 * @property {Array<string>} modules - Categorieën uit updateModules.js
 * @property {string} title - Titel in gewone taal
 */

/**
 * De update waar een verzoek aan gekoppeld is.
 *
 * Een id dat niet (meer) in de lijst staat geeft null: het verzoek blijft dan
 * gewoon zichtbaar, zonder regel over de update. Dat mag nooit iets kapotmaken.
 *
 * @param {Array<UpdateEntry>} updates - De hele lijst uit updates.json
 * @param {*} id - `UpdateID` van het verzoek
 * @returns {UpdateEntry|null}
 */
const findUpdateById = (updates, id) => {
    if (typeof id !== 'string' || id.trim() === '' || !Array.isArray(updates)) return null
    return updates.find((u) => u && u.id === id) || null
}

/**
 * De updates die in het statusvenster te kiezen zijn voor een verzoek.
 *
 * Gefilterd op de categorie van het verzoek, zodat de lijst kort blijft. De
 * update die al gekoppeld is staat er altijd bij, ook als hij een andere
 * categorie heeft — anders verdwijnt een bestaande koppeling uit beeld zodra
 * het venster opent. Volgorde is die van updates.json (nieuwste eerst).
 *
 * @param {Array<UpdateEntry>} updates - De hele lijst uit updates.json
 * @param {string} [module] - `Module` van het verzoek
 * @param {string} [currentId] - Huidige `UpdateID` van het verzoek
 * @returns {Array<UpdateEntry>}
 */
const updatesForRequest = (updates, module, currentId) => {
    if (!Array.isArray(updates)) return []
    return updates.filter((u) => {
        if (!u || typeof u.id !== 'string') return false
        if (currentId && u.id === currentId) return true
        if (!module) return true
        return Array.isArray(u.modules) && u.modules.includes(module)
    })
}

export { findUpdateById, updatesForRequest }
export default findUpdateById
